import queryString from 'query-string'
import { useLocation } from 'react-router-dom'

export function usePrototypeQueryParam() {
  const location = useLocation()
  const query = queryString.parse(location.search)

  return Array.isArray(query.prototype) ? query.prototype[0] : query.prototype
}
